import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { Image, SharingPopup } from 'C4';

const ImageCollection = (props) => {
  const { chapterCollection } = props;
  const { chapter } = chapterCollection[0];

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapterCollection).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: chapter.chapterTitle,
  };

  return (
    <div className="imageGrid__Container">
      <div className="imageGrid__Container--title">
        <h3>{chapter.chapterTitle}</h3>
        <h5>{`Chapter ${chapter.chapterNumber}`}</h5>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="imageGrid__Grid">
            {Object.values(chapterCollection).map((item, index) => {
              const { pageID, title, image } = item;
              return (
                <div className="imageGrid_Holder">
                  <div className="imageGrid_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    {image.length > 0 && <Image
                      key={pageID}
                      src={image}
                      gradient
                      href={image}
                      fancybox={chapter.chapterTitle}
                      options={fancyOptions}
                      caption={title}
                    />}
                  </div>
                  <h6 className="title">{title}</h6>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default ImageCollection;

ImageCollection.propTypes = {
  chapterCollection: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    pageID: PropTypes.number,
    image: PropTypes.string,
    url: PropTypes.string,
    chapter: PropTypes.shape({
      chapterNumber: PropTypes.number,
      chapterTitle: PropTypes.string,
      chapterImage: PropTypes.string,
    }),
  })).isRequired,
};
